import { logger } from '@/core/logger';
import { Linking } from 'react-native';

const SUPPORT_PHONE_NUMBER = '+97180025666';
const UAE_COUNTRY_CODE = '971';

function digitsOnly(phone: string): string {
    return phone.replace(/\D/g, '');
}

function localUaeDigits(phone: string): string {
    let digits = digitsOnly(phone);
    if (digits.startsWith(UAE_COUNTRY_CODE)) {
        digits = digits.slice(UAE_COUNTRY_CODE.length);
    } else if (digits.startsWith('0')) {
        digits = digits.slice(1);
    }
    return digits;
}

/**
 * Figma mobile display, e.g. +971-585-552-786
 */
export function formatPhoneNumberDisplay(phone: string): string {
    const local = localUaeDigits(phone);
    if (!local) {
        return '';
    }

    const groups: string[] = [];
    for (let index = 0; index < local.length; index += 3) {
        groups.push(local.slice(index, index + 3));
    }
    return `+${UAE_COUNTRY_CODE}-${groups.join('-')}`;
}

/** `tel:` target for a stored/profile phone number */
export function toDialablePhoneNumber(phone: string): string {
    const local = localUaeDigits(phone);
    return local ? `+${UAE_COUNTRY_CODE}${local}` : '';
}

/**
 * Opens the phone dialer with the given phone number
 * Works on iOS, Android, and Web
 */
export function openPhoneDialer(phoneNumber: string): void {
    const phoneUrl = `tel:${phoneNumber}`;
    Linking.openURL(phoneUrl).catch((err) => {
        logger.error('phoneUtils:Failed to open phone dialer', err);
    });
}

/**
 * Opens the phone dialer with the support phone number
 * Works on iOS, Android, and Web
 */
export function openSupportPhoneDialer(): void {
    openPhoneDialer(SUPPORT_PHONE_NUMBER);
}

